module.exports = __webpack_public_path__ + "img/CREDITOs.c2959f25.svg";